import { getBlobUrl } from "core/services/api"
// @ts-ignore
import { saveAs } from "file-saver"
import { store } from "./core/store"
import toastAction from "core/store/actions/toastAction"

const { dispatch } = store

const allowedExtensions = [
  ".jpg",
  ".jpeg",
  ".png",
  ".svg",
  ".webp",
  ".bmp",
  ".doc",
  ".docx",
  ".rtf",
  ".ppt",
  ".txt",
  ".xls",
  ".xlsx",
  ".pdf",
  ".wav",
]

const validateFileExtension = (fileName: any) => {
  const fileExtension: any = fileName
    ?.slice(((fileName?.lastIndexOf(".") - 1) >>> 0) + 2)
    ?.toLowerCase()
  return allowedExtensions?.includes("." + fileExtension)
}

const validateFileExtensionPdf = (
  fileName: string,
  allowedExtension: string
) => {
  const fileExtension = fileName.split(".").pop()
  return fileExtension === allowedExtension
}

async function getFileUrl(url: any, skipLoader: any = false) {
  const fileurl: any = await getBlobUrl(url, skipLoader)
  return fileurl?.blobUrl
}

const downloadFile = async (file: any) => {
  // const downloadUrl: any = await getFileUrl(file?.blobUrl)
  // var link = document.createElement("a")
  // link.href = downloadUrl
  // link.download = file?.name ? file?.name : "untitled"
  // link.click()
  try {
    const downloadUrl: any = await getFileUrl(file?.blobUrl)
    const response = await fetch(downloadUrl)
    const blob = await response.blob()
    const filename = file?.name ? file?.name : "document"
    saveAs(blob, filename)
  } catch (error) {
    console.error("Error downloading file:", error)
  }
}

const downloadFileViaUrl = async (url: any, name: any) => {
  // const downloadUrl: any = await getFileUrl(url)
  // var link = document.createElement("a")
  // link.href = downloadUrl
  // link.download = name ? name : "untitled"
  // link.click()
  try {
    const downloadUrl: any = await getFileUrl(url)
    const response = await fetch(downloadUrl)
    const blob = await response.blob()
    const filename = name ? name : "document"
    saveAs(blob, filename)
  } catch (error) {
    console.error("Error downloading file:", error)
  }
}

const downloadFileViaUrlExcel = async (url: string, name: string) => {
  try {
    const response = await fetch(url)
    const contentType = response.headers.get("content-type")
    const extension = getFileExtension(contentType, url, name)
    const filename = generateFilename(name, extension)
    const blob = await response.blob()
    // Create new blob with proper MIME type for Excel files
    if (isExcelFile(extension)) {
      const excelBlob = new Blob([blob], {
        type: "application/vnd.ms-excel",
      })
      saveAs(excelBlob, filename)
      dispatch(
        toastAction.updateToastTrue("Report downloaded successfully", "success")
      )
    } else {
      saveAs(blob, filename)
      dispatch(
        toastAction.updateToastTrue("Report downloaded successfully", "success")
      )
    }
  } catch (error) {
    console.error("Error downloading file:", error)
     dispatch(
       toastAction.updateToastTrue("Failed to download Report, Please try again", "error")
     )
    throw error
  }
}

const getFileExtension = (
  contentType: string | null,
  url: string,
  filename: string
): string => {
  // Try to get extension from content type
  if (contentType) {
    switch (contentType.toLowerCase()) {
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return ".xlsx"
      case "text/csv":
        return ".csv"
    }
  }
  const urlExtension = url.split(".").pop()?.toLowerCase()
  if (urlExtension && ["xls", "xlsx", "csv"].includes(urlExtension)) {
    return `.${urlExtension}`
  }
  const nameExtension = filename.split(".").pop()?.toLowerCase()
  if (nameExtension && ["xls", "xlsx", "csv"].includes(nameExtension)) {
    return `.${nameExtension}`
  }
  return ".xlsx"
}

const generateFilename = (name: string, extension: string): string => {
  const baseName = name.replace(/\.[^/.]+$/, "")
  const cleanName = baseName
    .replace(/%2F/g, "_")
    .replace(/%20/g, "_")
    .replace(/%3A/g, "_")
    .replace(/[^a-zA-Z0-9-_]/g, "_")

  return `${cleanName}${extension}`
}

const isExcelFile = (extension: string): boolean => {
  return [".xls", ".xlsx"].includes(extension.toLowerCase())
}

function checkEmptyFields(obj: any) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] !== "" && obj[key] !== undefined) {
      return obj
    }
  }
  return {}
}

function checkEmptyFieldsInArray(arr: any) {
  for (const obj of arr) {
    for (const key in obj) {
      if (
        obj.hasOwnProperty(key) &&
        obj[key] !== "" &&
        obj[key] !== undefined
      ) {
        return arr
      }
    }
  }

  return []
}

function checkEmptyFieldsInArrayWithArrays(arr: any) {
  if (
    arr.every((obj: any) => {
      for (const key in obj) {
        if (Array.isArray(obj[key])) {
          if (
            !obj[key].every((item: any) => item === "" || item === undefined)
          ) {
            return false
          }
        } else if (obj[key] !== "" && obj[key] !== undefined) {
          return false
        }
      }
      return true
    })
  ) {
    return []
  }
  return arr
}

//Example [{},{},{}]
function checkForListOfObject(list: any) {
  if (
    list === null ||
    list === undefined ||
    (Array.isArray(list) &&
      list.every((obj) => {
        for (const key in obj) {
          if (obj.hasOwnProperty(key) && obj[key] !== undefined) {
            return false // Object has at least one non-undefined key
          }
        }
        return true // All keys are undefined
      }))
  ) {
    return []
  } else {
    return list
  }
}
const fileUtils = {
  validateFileExtension,
  getFileUrl,
  downloadFile,
  downloadFileViaUrl,
  downloadFileViaUrlExcel,
  checkEmptyFields,
  checkEmptyFieldsInArray,
  checkEmptyFieldsInArrayWithArrays,
  checkForListOfObject,
  validateFileExtensionPdf,
}

export default fileUtils
